import { Banners } from "../modules";

export const BannersPage = () => {
  return <Banners />;
};
